import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setAuthTokenGetter } from '../services/apiService';
import { setApiSliceAuthGetter } from '../store/slices/apiSlice';

/**
 * Component that sets up Clerk auth token for API requests.
 * Must be rendered inside ClerkProvider and SignedIn.
 */
const ClerkTokenProvider = ({ children }) => {
  const { getToken } = useAuth();

  useEffect(() => {
    // Set the token getter function for all API services
    setAuthTokenGetter(getToken);
    setApiSliceAuthGetter(getToken);

    // Cleanup on unmount
    return () => {
      setAuthTokenGetter(null);
      setApiSliceAuthGetter(null);
    };
  }, [getToken]);

  return children;
};

export default ClerkTokenProvider;
